/**
 * Retourne le mois avec élision : "d'avril", "de mars", etc.
 * @param {string} monthName
 * @returns {string}
 */
const getMonthWithElision = monthName => {
  const vowels = ['a', 'e', 'i', 'o', 'u', 'A', 'E', 'I', 'O', 'U']
  const firstLetter = monthName.charAt(0)
  if (vowels.includes(firstLetter)) {
    return `d'${monthName}`
  } else {
    return `de ${monthName}`
  }
}

const upperFirstLetter = word => word.charAt(0).toUpperCase() + word.substring(1).toLowerCase()
const lowerFirstLetter = word => word.charAt(0).toLowerCase() + word.substring(1)
const matcher = {
  numberMatcher: (tab, search = '', attribute) => tab.filter(element => new RegExp(`${search}.*`).test(element[attribute])),
  stringMatch: (tab, search = '', attribute) => tab.filter(element => new RegExp(`${flattenString(search)}.*`).test(flattenString(element[attribute])))
}
const addPluriel = (word, length) => {
  if (length < 2) {
    return word
  } if (word.slice(-3) === 'eau') {
    return `${word}x`
  }
  return `${word}s`
}
const flattenString = string => removeSpace(removeLinkWord(removeAccent(string.toLowerCase())))
const removeAccent = string => string
  .replace(/é|ê|è/, 'e')
  .replace(/î|ï/, 'i')
const pluralize = (val, words, defaultLetter = 's') => (val > 1 ? words.map(w => w.concat(`${defaultLetter} `)).toString().replace(/,/g, '') : words.join(' '))
const removeLinkWord = string => string.replace(/( de)|( a)|( à)|(de )|/, '')

const removeSpace = string => {
  if (string.charAt(0) === ' ') {
    return removeSpace(string.substr(1))
  } if (string.charAt(string.length - 1) === ' ') {
    return removeSpace(string.substr(0, string.length - 1))
  }
  return string
}

const removeSpaces = string => string.replace(/ /g, '')

const capitalize = string => {
  const lower = string.toLowerCase()
  return string.charAt(0).toUpperCase() + lower.slice(1)
}

const makeSentence = words => upperFirstLetter(words.filter(word => !(String(word).toLowerCase() === 'entier'))
  .reduce((sentence, word) => makeSimpleLiason(sentence, word), ''))

const makeSentenceWithState = (state, raccourci = false) => {
  const Ids = ['idPreparation', 'idQualite', 'idTaille', 'idLabel']
  return state.reduce((sentence, sentenceStatePart) => {
    if (sentenceStatePart.idPoisson) {
      return makeSimpleLiason(sentence, getName(sentenceStatePart, raccourci), raccourci)
    } if (Ids.includes(sentenceStatePart.getIdAttribute())) {
      return `${sentence} ${getName(sentenceStatePart, raccourci)}`
    } if (String(getName(sentenceStatePart, raccourci)).toLowerCase() === 'entier') {
      return sentence
    }
    return makeSimpleLiason(sentence, getName(sentenceStatePart, raccourci), raccourci)
  }, '')
}
const getName = (statePart, raccourci) => {
  if (raccourci) {
    return statePart[statePart.getRaccourciAttribute()]
  }
  return statePart[statePart.getNameAttribute()]
}
const isNumber = n => /^-?[\d.]+(?:e-?\d+)?$/.test(n)
const makeSimpleLiason = (word1, word2, raccourci = false) => {
  const voyelles = ['a', 'e', 'i', 'o', 'u', 'y', 'é']
  if (word1 === '') {
    return word1 + word2
  } if (!isNaN(word1) || raccourci) {
    return `${word1} ${word2}`
  } if (voyelles.find(element => element === word2.toLowerCase().charAt(0))) {
    return `${word1} d'${word2}`
  } if (new RegExp('[A-z]').test(word2.charAt(0))) {
    return `${word1} de ${word2}`
  }
  return `${word1} ${word2}`
}
/**
    * @param {String} word1 the first word to link
    * @param {String} word2 the second word to link
    */
const makeLiaison = (word1, word2) => {
  const voyelles = ['a', 'e', 'i', 'o', 'u', 'y', 'é']
  if (voyelles.find(element => element === word2.charAt(0))) { return `${upperFirstLetter(word1)} d'${word2}` }
  return `${upperFirstLetter(word1)} de ${word2}`
}

/**
 * @param {String} word1 The word to upperCase
 * @param {String} word2 The word to upperCase
 */
const makeLiaisonWithEntier = (word1, word2) => {
  if (word1.toLowerCase() === 'entier') { return `${upperFirstLetter(word2)} ${word1}` }
  return makeLiaison(word1, word2)
}

const searchOnTab = (tab, search = '', attribute) => {
  if (search.length === 0) {
    return tab
  }
  return matcher.stringMatch(tab, search, attribute)
}

/**
 * Get list of poisson without same entries
 * @param {Array} tab Array of object who are compared with matcher.
 * @param {Object} matcher Object are compared with codePoisson Array.
 */
const getCombinaison = (tab, matcher) => tab.filter(codeline => Object.getOwnPropertyNames(matcher)
  .map(element => this.checkAttribute(matcher, codeline, element))
  .reduce((prec, element) => // check if all attribute are true
    prec && element,
  true))

/**
 * Predicate to know if matcher and element are undefined or ok
 * @param {Object} matcher object to compare
 * @param {Object} element of codePoisson Array
 * @param {String} attribute used to compare
 */
const checkAttribute = (matcher, element, attribute) => matcher[attribute] === undefined || matcher[attribute] === element[attribute]

const levenshteinDistance = (a, b) => {
  const matrix = []

  for (let i = 0; i <= b.length; i++) {
    matrix[i] = [i]
  }

  for (let j = 1; j <= a.length; j++) {
    matrix[0][j] = j
  }

  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      const indicator = a[j - 1] === b[i - 1] ? 0 : 1
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1, // deletion
        matrix[i][j - 1] + 1, // insertion
        matrix[i - 1][j - 1] + indicator // substitution
      )
    }
  }

  return matrix[b.length][a.length]
}

export default {
  upperFirstLetter,
  lowerFirstLetter,
  makeSentence,
  matcher,
  capitalize,
  removeSpace,
  removeSpaces,
  makeSimpleLiason,
  checkAttribute,
  makeSentenceWithState,
  getCombinaison,
  removeAccent,
  searchOnTab,
  addPluriel,
  makeLiaisonWithEntier,
  makeLiaison,
  pluralize,
  levenshteinDistance,
  isNumber,
  getMonthWithElision
}
